export default __webpack_public_path__ + "static/media/illustration-algostudy-n-w.c60b99c7.png";